"use client";

import { BookOpen, FileText } from "lucide-react";
import { useWorkspace, WorkspaceFile } from "@/lib/workspace-context";

interface BacklinksPanelProps {
  file: WorkspaceFile;
  onOpen: (fileId: string) => void;
}

/**
 * Panel que muestra los documentos que enlazan HACIA el archivo activo
 * (backlinks / vínculos de retroceso). Sólo se renderiza si hay al menos uno.
 */
export function BacklinksPanel({ file, onOpen }: BacklinksPanelProps) {
  const { getBacklinks } = useWorkspace();
  const backlinks = getBacklinks(file.id);

  if (backlinks.length === 0) return null;

  return (
    <div className="mt-12 pt-6 border-t border-border/30 select-none">
      <h3 className="text-xs font-bold uppercase tracking-wider text-muted-foreground/50 mb-3 flex items-center gap-1.5">
        <BookOpen className="w-3.5 h-3.5 text-primary" />
        Vínculos de retroceso ({backlinks.length})
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {backlinks.map((backlink) => (
          <div
            key={backlink.id}
            onClick={() => onOpen(backlink.id)}
            className="p-3 rounded-xl bg-secondary/15 hover:bg-secondary/40 border border-border/30 hover:border-primary/20 transition-all cursor-pointer group flex items-start gap-2.5"
          >
            <FileText className="w-4 h-4 text-muted-foreground/60 group-hover:text-primary transition-colors mt-0.5 shrink-0" />
            <div className="min-w-0">
              <h4 className="text-xs font-semibold text-foreground group-hover:text-primary transition-colors truncate">
                {backlink.name.replace(".md", "")}
              </h4>
              <p className="text-[10px] text-muted-foreground truncate max-w-xs mt-0.5">
                {backlink.content?.replace(/#+\s+/g, "").slice(0, 80)}...
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
